import { useAppSelector } from 'features/app/hooks';
import { isPreviousCallIdExistSelector } from 'features/call/vrs-call-comments/store';
import { VrsCallSurveyHeader } from 'features/call/vrs-call/components';
import { BaseHeader } from 'features/ui/elements';
import { selectCallPageStatus } from 'features/call/call-ui-state/store';
import { CallPageStatus } from 'features/call/call-ui-state/enums';

export const useVrsCallHeader = () => {
  const isPreviousCallIdExist = useAppSelector(isPreviousCallIdExistSelector);
  const callPageStatus = useAppSelector(selectCallPageStatus);

  let header;

  if (callPageStatus === CallPageStatus.SURVEY && isPreviousCallIdExist) {
    header = <VrsCallSurveyHeader />;
  } else {
    header = <BaseHeader />;
  }

  return { header };
};
